import { FC, MouseEvent, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';

import { TariffFeature } from 'src/types';
import { useTariff } from 'src/hooks/use-tariff';

import { TariffLockIcon } from './tariff-lock-icon';
import { TariffLockedView } from './tariff-locked-view';

type Props = {
  feature: TariffFeature;
  children: ReactNode;
  mode?: 'action' | 'page';
  hideBadge?: boolean;
  sx?: SxProps<Theme>;
};

export const TariffFeatureGuard: FC<Props> = ({
  feature,
  children,
  mode = 'action',
  hideBadge = false,
  sx,
}) => {
  const { canUseFeature, openUpgradeDialog } = useTariff();

  if (canUseFeature(feature)) return <>{children}</>;

  if (mode === 'page') return <TariffLockedView />;

  const handleBlockedClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    openUpgradeDialog({ type: 'feature', feature });
  };

  return (
    <Box
      onClickCapture={handleBlockedClick}
      sx={{ position: 'relative', display: 'inline-flex', cursor: 'pointer', ...sx }}
    >
      {children}
      {!hideBadge && (
        <TariffLockIcon sx={{ position: 'absolute', top: -6, right: -6, zIndex: 1 }} />
      )}
    </Box>
  );
};
